var clvbase;
! function($) {
    "use strict";
    clvbase = function() {
        var baselTheme = {
            popupEffect: "",
            supports_html5_storage: !1,
            ajaxLinks: ""
        };
        try {
            baselTheme.supports_html5_storage = "sessionStorage" in window && null !== window.sessionStorage, window.sessionStorage.setItem("basel", "test"), window.sessionStorage.removeItem("basel")
        } catch (e) {
            baselTheme.supports_html5_storage = !1
        }
        return {
          init: function() {
            this.shopcarousel();
            this.oneSlide();
            this.brandImage();
            this.quote();
            this.instagramd();
            this.timeline();
            this.masonry();
            this.lookbook();
          },

          shopcarousel: function() {
            void 0 !==  $(".slider.owl-carousels ").each(
              function(e) {
                var t = $(this).data("limit"),
                    o = $(this).data("nav"),
                    s = $(this).data("dots"),
                    a = ($(this).data("medium"), $(this).data("time")),
                    i = $(this).data("loop"),
                    n = $(this).data("autoplay"),
                    l = {
                       itemsCustom : [ 
                      [320, 1],
                      [450, 1],
                      [600, 2],
                      [700, 2],
                      [900, 3],
                      [1000, t],
                      [1200, t],
                      [1400, t],
                      [1600, t]
                      ],
                      autoPlay : false,
                      stopOnHover : false,

                      lazyLoad : false,
                      lazyFollow : true,
                      lazyEffect : "fade",
                      pagination : false,

                      // Navigation
                      navigation : true,
                      navigationText : ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
                      rewindNav : true,
                      scrollPerPage : false,
                    };
                $(this).owlCarousel(l)
              })
          },
          oneSlide: function() {
            void 0 !==  $(".one.owl-carousel ").each(
              function(e) {
                var t = $(this).data("limit"),
                    o = $(this).data("nav"),
                    s = $(this).data("dots"),
                    a = ($(this).data("medium"), $(this).data("time")),
                    i = $(this).data("loop"),
                    n = $(this).data("autoplay"),
                    l = {
                      rtl: $("body").hasClass("rtl"),
                      items: 1,
                      autoplay: true,
                      autoplayTimeout: 5000,
                      dots: false,
                      autoplayHoverPause:true,
                      nav: true,
                      autoheight: !0,
                      slideBy: "page",
                      navText: ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
                      loop: false,
                      onRefreshed: function() {
                        $(window).resize()
                      }
                    };
                $(this).owlCarousel(l)
              })
          },
          brandImage: function() {
            void 0 !==  $("#logo-brand.slide").each(
              function(e) {
                var t = $(this).data("limit"),
                    o = $(this).data("nav"),
                    s = $(this).data("dots"),
                    a = ($(this).data("medium"), $(this).data("time")),
                    i = $(this).data("loop"),
                    n = $(this).data("autoplay"),
                    l = {
                      itemsCustom : [ 
                        [0, 1],
                        [450, 2],
                        [600, 3],
                        [700, 4],
                        [1000, 5],
                        [1200, 6],
                        [1400, 6],
                        [1600, 6]
                      ],
                      autoPlay : true,
                      stopOnHover : false,

                      lazyLoad : false,
                      lazyFollow : true,
                      lazyEffect : "fade",
                      pagination : true,

                      // Navigation
                      navigation : false,
                      //navigationText : ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
                      //rewindNav : true,
                      //scrollPerPage : false,
                    };
                $(this).owlCarousel(l)
              })
          },
          quote: function() {
            void 0 !==  $(".quotes-slider.owl-carousel ").each(
              function(e) {
                var d = $(this).data("desktop"),
                    t = $(this).data("tablet"),
                    m = $(this).data("mobile"),
                    a = ($(this).data("medium"), $(this).data("time")),
                    i = $(this).data("loop"),
                    n = $(this).data("autoplay"),
                    l = {
                      rtl: $("body").hasClass("rtl"),
                      items: d,
                      responsive: {
                        979: {
                          items: d
                        },
                        768: {
                          items: t
                        },
                        479: {
                          items: m
                        },
                        0: {
                          items: m
                        }
                      },
                      autoplay: true,
                      autoplayTimeout: 5000,
                      dots: true,
                      nav: true,
                      autoheight: !0,
                      autoplayHoverPause:true,
                      slideBy: "page",
                      navText: !1,
                      loop: true,
                      onRefreshed: function() {
                        $(window).resize()
                      }
                    };
                $(this).owlCarousel(l)
              })
          },
          instagramd: function() {
            void 0 !==  $(".instagrams").each(
              function(e) {
                var d = $(this).data("user"),
                    t = $(this).data("token"),
                    m = $(this).data("clienid"),
                    a = ($(this).data("medium"), $(this).data("time")),
                    i = $(this).data("limit"),
                    n = $(this).data("image"),
                    feed = new Instafeed({
                      get: "user",    

                      userId: d,
                      accessToken: t,

                      clientId: m,
                      limit: i,
                      resolution: n,
                      after: function() {
                        $('.instagram > a').attr( "target", "_blank" );
                        $(".instagram.slide").owlCarousel({
                          loop:true,
                          margin:1,
                          responsiveClass:true,
                          dots: false,
                          navText: ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
                          responsive:{
                            0:{
                              items:1,
                              nav:true
                            },
                            600:{
                              items:2,
                              nav:true
                            },
                            800:{
                              items:3,
                              nav:true
                            },
                            1000:{
                              items:i,
                              nav:true,
                              loop:false
                            }
                          }
                        });

                        var count_a = jQuery(".instagram.grid" ).width();
                        var width_item = count_a / i - 0.3 ;
                        jQuery(".instagram.grid a").css("width", width_item);
                        jQuery('.instagram.grid > a').addClass('col-lg-2');
                        jQuery('.instagram.grid ').addClass('row');
                      }
                    });
                feed.run();
              }
            )
          },
          timeline: function() {
            void 0 !==  $(".timeline-block").each(
              function(e) {
                var t = $(this).data("time"),
                    l = {
                      TargetDate:t,

                      DisplayFormat:"<div class='day'><span class='no'>%%D%%</span><span class='text'>days</span></div><div class='hours'><span class='no'>%%H%%</span><span class='text'>hours</span></div><div class='min'><span class='no'>%%M%%</span><span class='text'>min</span></div><div class='second'><span class='no'>%%S%%</span><span class='text'>sec</span></div>",
                      FinishMessage: "Expired",
                      onRefreshed: function() {
                        $(window).resize()
                      }
                    };
                $(this).lofCountDown(l)
              })
          },
          lookbook: function() {
            void 0 !==  $(".block-slide-5").each(
              function(e) {
                var header_height = jQuery('#header-content' ).outerHeight();
                console.log(header_height);
                var footer_height = jQuery('.footer-container' ).outerHeight();
                console.log(footer_height);
                 var heightimgrs = jQuery(window).height() - footer_height;
                console.log(heightimgrs);
                var t = $(this).data("time"),
                    l = {
                      itemsCustom : [ 
                        [0, 1],
                        [1600, 1]
                      ],
                      autoPlay : true,
                      stopOnHover : false,
                      lazyLoad : false,
                      lazyFollow : true,
                      lazyEffect : "fade",
                      pagination : false,
                      navigation : true,
                      navigationText : ['<i class="cs-font clever-icon-prev"></i>','<i class="cs-font clever-icon-next"></i>'],
                      //rewindNav : true,
                      //scrollPerPage : false,
                    };
                $(this).height(heightimgrs);
                $('.main-slide-content').height(heightimgrs);
                $( window ).resize(function() {
                  var header_height = jQuery('#header-content' ).height();
                  var footer_height = jQuery('.footer-container' ).height();
                  var heightimgrs = jQuery( window ).height() - footer_height;
                  $(this).height(heightimgrs);
                  $('.main-slide-content').height(heightimgrs);
                });
                $(this).owlCarousel(l)
              })
          },
          masonry: function() {
             void 0 !==  $(".mansonry").each(
               function(e) {
                
                  var isotope = $(this).isotope({
                     layoutMode: 'masonry', 		
                     masonry: {
                       columnWidth: 1
                     }					
                   });
                 
               })
           }
        }
    }()
}(jQuery), 
  jQuery(document).ready(function() {
    clvbase.init()
}), jQuery(document).on("shopify:section:load", clvbase.shopcarousel).on("shopify:section:unload", clvbase.shopcarousel).on("shopify:section:select", clvbase.shopcarousel).on("shopify:section:deselect", clvbase.shopcarousel).on("shopify:block:select", clvbase.shopcarousel).on("shopify:block:deselect", clvbase.shopcarousel)
jQuery(document).on("shopify:section:load", clvbase.quote).on("shopify:section:unload", clvbase.quote).on("shopify:section:select", clvbase.quote).on("shopify:section:deselect", clvbase.quote).on("shopify:block:select", clvbase.quote).on("shopify:block:deselect", clvbase.quote),
  jQuery(document).on("shopify:section:load", clvbase.instagramd).on("shopify:section:unload", clvbase.instagramd).on("shopify:section:select", clvbase.instagramd).on("shopify:section:deselect", clvbase.instagramd).on("shopify:block:select", clvbase.instagramd).on("shopify:block:deselect", clvbase.instagramd),
  jQuery(document).on("shopify:section:load", clvbase.brandImage).on("shopify:section:unload", clvbase.brandImage).on("shopify:section:select", clvbase.brandImage).on("shopify:section:deselect", clvbase.brandImage).on("shopify:block:select", clvbase.brandImage).on("shopify:block:deselect", clvbase.brandImage),
  jQuery(document).on("shopify:section:load", clvbase.oneSlide).on("shopify:section:unload", clvbase.oneSlide).on("shopify:section:select", clvbase.oneSlide).on("shopify:section:deselect", clvbase.oneSlide).on("shopify:block:select", clvbase.oneSlide).on("shopify:block:deselect", clvbase.oneSlide),
  jQuery(document).on("shopify:section:load", clvbase.timeline).on("shopify:section:unload", clvbase.timeline).on("shopify:section:select", clvbase.timeline).on("shopify:section:deselect", clvbase.timeline).on("shopify:block:select", clvbase.timeline).on("shopify:block:deselect", clvbase.timeline),
  jQuery(document).on("shopify:section:load", clvbase.masonry).on("shopify:section:unload", clvbase.masonry).on("shopify:section:select", clvbase.masonry).on("shopify:section:deselect", clvbase.masonry).on("shopify:block:select", clvbase.masonry).on("shopify:block:deselect", clvbase.masonry),
  jQuery(document).on("shopify:section:load", clvbase.lookbook).on("shopify:section:unload", clvbase.lookbook).on("shopify:section:select", clvbase.lookbook).on("shopify:section:deselect", clvbase.lookbook).on("shopify:block:select", clvbase.lookbook).on("shopify:block:deselect", clvbase.lookbook);
